import SearchResultsTabProducts from '@maison/components/search/SearchResultsTabProducts.vue';
import SearchResultsTabArticles from '@maison/components/search/SearchResultsTabArticles.vue';
import SearchResultsTabStores from '@maison/components/search/SearchResultsTabStores.vue';
import Product from '@maison/components/common/Product';
import SearchArticleCard from '@maison/components/search/SearchArticleCard.vue';
import SearchStoreCard from '@maison/components/search/SearchStoreCard.vue';

export const TAB_ALL = 'all';
export const TAB_PRODUCTS = 'products';
export const TAB_ARTICLES = 'articles';
export const TAB_STORES = 'stores';

export const TABS_ORDER = [TAB_PRODUCTS, TAB_ARTICLES, TAB_STORES];

export const URL_QUERY_SEARCH_NAME = 'search.keyword';
export const URL_FILTERS_SEARCH_NAME = 'search';
export const MIN_TERM_LENGTH = 3;
export const SEARCH_QUERY_DELAY = 400;

export const getTabComponent = (tab) => {
  switch (tab) {
    case TAB_PRODUCTS:
      return SearchResultsTabProducts;
    case TAB_ARTICLES:
      return SearchResultsTabArticles;
    case TAB_STORES:
      return SearchResultsTabStores;
    default:
      throw new Error(`[Search] Tab '${tab}' is not supported`);
  }
};

export const getTabItemComponent = (tab) => {
  switch (tab) {
    case TAB_PRODUCTS:
      return Product;
    case TAB_STORES:
      return SearchStoreCard;
    default:
      return SearchArticleCard;
  }
};
